<style lang="scss" scoped>
.table-header {
  border: 1px solid #ebeef5;
  border-bottom: none;
  height: 50px;
}
.refresh {
  background-color: #f5f5f5;
  width: 50px;
  &:hover .icon_refresh {
    color: rgba(0, 0, 0, 0.6);
  }
}
.icon_refresh {
  color: #999;
  line-height: 50px;
}
.operation {
  white-space: nowrap;
}
.mb20 {
  margin-bottom: 60px;
}
.el-tag {
  margin-left: 10px;
}
</style>
<template>
  <div class="account height_100 flex_tb">
    <!-- 條件刪選 -->
    <collapse @seach="state.seach" :order_no="state.user.order_no"/>
    <div class="width_100 table-header sizing flex_lr_m">
      <div>
        <i class="el-icon-s-grid pad20" style="color: #999"></i>
        <el-button type="primary" size="mini" @click="export_cli"
          >導出表格</el-button
        >
        <el-button
          type="danger"
          size="mini"
          :disabled="!state.delAccountId.length"
          @click="dels_confirm"
          >批量刪除</el-button
        >
      </div>
      <div class="refresh sizing height_100 flex_c_m" @click="refresh">
        <i class="el-icon-refresh cursor fonts-22 icon_refresh"></i>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :data="state.tableData"
      height="100%"
      border
      style="width: 100%"
      class="flex1"
      id="exportTab"
      @selection-change="selection_change"
    >
      <!-- <el-table-column prop="id" label="id" sortable> </el-table-column> -->
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="expand">
        <template #default="props">
          <div>
            <el-card
              class="box-card"
              v-for="item in props.row.order_details"
              :key="item.id"
              shadow="never"
              style="margin-bottom: 20px"
            >
              <template #header>
                <div class="card-header">
                  <span>商品信息</span>
                </div>
              </template>
              <el-row>
                <el-col :span="8" class="flex_c_m mb20">
                  <span style="margin-right: 10px">商品名稱：</span>
                  <span>{{ item.goods_name }}</span>
                </el-col>
                <el-col :span="8" class="flex_c_m mb20">
                  <span style="margin-right: 10px">商品圖片：</span>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.goods_img"
                  ></el-image>
                </el-col>
                <el-col :span="8" class="flex_c_m mb20">
                  <span style="margin-right: 10px">購買數量：</span>
                  <span>{{ item.number }}</span>
                </el-col>
                <el-col :span="8" class="flex_c_m mb20">
                  <span style="margin-right: 10px">购买价格：</span>
                  <span>{{ item.price }}</span>
                </el-col>
                <el-col :span="8" class="flex_c_m mb20">
                  <span style="margin-right: 10px">预约时间：</span>
                  <span>{{ item.subscribe_time }}</span>
                </el-col>
                <el-col :span="8" class="flex_c_m mb20">
                  <span style="margin-right: 10px">商品单价：</span>
                  <span>{{ item.unit_price }}</span>
                </el-col>
                <el-col :span="24" class="mb20">
                  <span style="margin-right: 10px">商品屬性：</span>
                  <el-tag
                    :disable-transitions="false"
                    v-for="curr in item.order_skus"
                    :key="curr.id"
                    :closable="false"
                  >
                    {{ curr.attr_values_name }} (<span style="color: red"
                      >${{ curr.attr_values_price }}</span
                    >)
                  </el-tag>
                  <span v-if="!item.order_skus.length">無</span>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="order_no" label="订单号" min-width="80">
      </el-table-column>
      <el-table-column prop="name" label="收获名" min-width="80">
      </el-table-column>
      <el-table-column prop="phone" label="电话" min-width="80">
      </el-table-column>
      <el-table-column prop="address" label="地址" min-width="80">
      </el-table-column>
      <el-table-column prop="money" label="总金额" min-width="80">
      </el-table-column>
      <el-table-column prop="receiving_method" label="取貨方式" min-width="80">
        <template #default="scope">
          {{ scope.row.receiving_method == 1 ? "自取" : "直送 " }}
        </template>
      </el-table-column>
      <el-table-column prop="receiving_method" label="優惠券" min-width="80">
        <template #default="scope">
          {{
            scope.row.coupon_type == 1
              ? `立減${scope.row.discount}`
              : scope.row.coupon_type == 2
              ? `滿${scope.row.lowest}減${scope.row.discount}`
              : scope.row.coupon_type == 3
              ? `立折${scope.row.discount}折`
              : scope.row.coupon_type == 4
              ? `滿${scope.row.lowest}打${scope.row.discount}折`
              : "無"
          }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="創建時間" min-width="100">
      </el-table-column>
      <el-table-column prop="payment_mode" label="支付方式" min-width="80">
        <template #default="scope">
          {{ scope.row.payment_mode == 1 ? "PayPal支付" : "錢包支付" }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="狀態">
        <template #default="scope">
          <span>{{ scope.row.status ? "正常" : "禁用" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="member_name"
        label="操作"
        min-width="180px"
        fixed="right"
      >
        <template #default="scope">
          <div class="operation height_100 flex_c_m" style="flex-wrap: wrap">
            <el-button type="primary" size="mini" @click="lookInfo(scope.row)"
              >生成發票</el-button
            >
            <el-button type="danger" size="mini" @click="deleteInfo(scope.row)"
              >刪除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分頁 -->
    <div class="flex_m_r pain pad20">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="state.user.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Number(state.count)"
      >
      </el-pagination>
    </div>
    <!-- 彈窗 -->
    <pop-up
      :dialogVisible="state.dialogVisible"
      :userId="'' + state.userId"
      @toggleDialogVisible="toggleDialogVisible"
      @reloadData="reloadData"
    />
    <!-- 提示框 -->
    <el-dialog title="提示" v-model="state.dialog" width="400px">
      <span>確定刪除嗎？</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="state.dialog = false">取 消</el-button>
          <el-button type="primary" @click="dels_confirm">確 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, getCurrentInstance } from "vue";
import Collapse from "./components/collapse";
import PopUp from "./components/pop-up";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  components: {
    Collapse,
    PopUp,
  },
  setup() {
    const req_table_data = () => {
      $http.getOrderManagementList(state.user).then((res) => {
        if (res.status !== 200) return;
        state.tableData = res.data.data;
        state.count = res.data.count;
      });
    };

    const state = reactive({
      tableData: [], // 表格数据
      user: {
        // 请求参数
        limit: 10,
        page: 1,
        order_no: "",
        time: "",
      },
      count: "", // 總條數
      seach(data) {
        // 查询里面的数据
        state.user.order_no = data.seatch_name;
        state.user.time = data.time;
        req_table_data();
      },
      dialogVisible: false, // 弹窗开关
      dialog: false, // 提示框开关
      delAccountId: [], // 批量刪除的id
      delUserId: [], // 单个删除的id
      userId: "", // 用户id
    });

    const proxy = getCurrentInstance().appContext.config.globalProperties;
    const { $http, $message, $router } = proxy;

    if ($router.currentRoute.value.query.order_id) {
      state.user.order_no = $router.currentRoute.value.query.order_id;
    }

    // init
    req_table_data();

    // 分頁組件改變页数
    const handleCurrentChange = (val) => {
      state.user.page = val;
      req_table_data();
    };

    // 分頁組件改變每頁顯示条数
    const handleSizeChange = (val) => {
      state.user.limit = val;
      req_table_data();
    };

    // 刷新
    const refresh = () => {
      req_table_data();
    };

    // 弹出层的显示开关
    const toggleDialogVisible = () => {
      state.dialogVisible = false;
    };

    // 弹出层点击确定触发
    const reloadData = (data) => {
      console.log(data);
      req_table_data();
    };

    // 选中的id数组
    const selection_change = (selection) => {
      state.delAccountId = selection.map((item) => {
        item = item.id;
        return item;
      });
    };

    // 选中的id数组
    const del_accout = () => {
      state.delUserId = [];
      state.dialog = true;
    };

    // 确定弹出层点击确定
    const dels_confirm = async () => {
      const res = await $http.delOrderManagementList({
        id: state.delUserId.length === 0 ? state.delAccountId : state.delUserId,
      });
      if (res.status !== 200) return;
      req_table_data();
      $message.success("刪除成功");
      state.dialog = false;
    };

    // 刪除用戶
    const deleteInfo = (data) => {
      state.delUserId = [data.id];
      state.dialog = true;
    };

    // 查看数据列表
    const lookInfo = async (data) => {
      console.log(data);
      const res = await $http.createInvoice({
        id: data.id,
      });
      if (res.status !== 200) return;
      $message.success("操作成功");
      // state.dialog = false;
      // state.dialogVisible = true;
    };

    const export_cli = () => {
      var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#exportTab"),
        xlsxParam
      );

      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "銷售管理.xlsx"
        );
        $message.success("導出成功");
      } catch (e) {
        if (typeof console !== "undefined") {
          console.log(e, wbout);
        }
      }
      return wbout;
    };

    return {
      state,
      handleCurrentChange,
      handleSizeChange,
      refresh,
      toggleDialogVisible,
      reloadData,
      selection_change,
      del_accout,
      dels_confirm,
      deleteInfo,
      lookInfo,
      export_cli,
    };
  },
};
</script>
